import { type QuestionData, QuestionOptionType } from '../support.type';
import { type EditableQuestion } from './EditableQuestion';
import { type LinkQuestion } from './LinkQuestion';
import { type BillQuestion } from './BillQuestion';

export class Question {
    readonly key: number;
    readonly title: string;
    readonly subTitle: string;
    readonly metaData: string;
    protected readonly _value: string;
    private readonly _isSelected: boolean;
    readonly questionOptionType: QuestionOptionType;
    readonly needApproval: boolean;
    readonly needLogin: boolean;

    constructor(question: QuestionData) {
        this.needApproval = !!question.needApproval;
        this.key = question.key;
        this.title = question.title;
        this.subTitle = question.subTitle;
        this.metaData = question.metaData;
        this._value = question.value;
        this._isSelected = question.isSelected;
        this.questionOptionType = question.questionOptionType;
        this.needLogin = !!question.needLogin;
    }

    isEditable(): this is EditableQuestion {
        return this.questionOptionType === QuestionOptionType.Editable;
    }

    isBill(): this is BillQuestion {
        return this.questionOptionType === QuestionOptionType.ChooseBill;
    }

    isLink(): this is LinkQuestion {
        return this.questionOptionType === QuestionOptionType.Link;
    }

    get value() {
        return this._value;
    }

    get isSelected() {
        return this._isSelected;
    }
}
